import { Direction, Directions } from 'constants/directions';
import React from 'react';

interface Props {
  direction: Direction;
}

const rotation = {
  [Directions.UP]: 180,
  [Directions.DOWN]: 0,
  [Directions.LEFT]: 90,
  [Directions.RIGHT]: 270,
};

const ChevronDirectional: React.FC<Props> = ({ direction }: Props) => {
  return (
    <svg
      height="24px"
      width="24px"
      viewBox="0 0 25 24"
      style={{
        fill: '#4b585d',
      }}
      transform={`rotate(${rotation[direction]})`}
    >
      <path d="M4.711 8.771l7.292 7.528c.29.276.737.267 1.013-.019l7.29-7.527c.265-.297.257-.75-.017-1.033l-.083-.073c-.289-.219-.692-.192-.949.073L12.5 14.696 5.725 7.701c-.29-.276-.737-.267-1.014.019-.281.29-.281.76 0 1.051z" />
    </svg>
  );
};
export default ChevronDirectional;
